import { TActions } from '../../../types/actions';
import {
  PUBLISH_OFFER_FAIL,
  PUBLISH_OFFER_START,
  PUBLISH_OFFER_SUCCESS,
  SET_IS_SUBAGENT_NOT_ENOUGH_MONEY,
} from './actions';
import { defaultState } from './defaultState';
import { EPublishOfferStatus, IPublishInfoState } from './types';

export function publishInfo(state: IPublishInfoState = defaultState, action: TActions): IPublishInfoState {
  switch (action.type) {
    case PUBLISH_OFFER_START: {
      return {
        ...state,
        status: EPublishOfferStatus.pending,
        errorCode: null,
        errorMessage: null,
        errors: null,
      };
    }

    case PUBLISH_OFFER_SUCCESS: {
      return {
        ...state,
        status: EPublishOfferStatus.success,
      };
    }

    case PUBLISH_OFFER_FAIL: {
      return {
        ...defaultState,
        status: EPublishOfferStatus.fail,
        ...action.payload,
      };
    }

    case SET_IS_SUBAGENT_NOT_ENOUGH_MONEY: {
      return {
        ...state,
        isSubagentNotEnoughMoney: action.payload,
      };
    }

    default:
      return state;
  }
}
